import apiFiles from "@/services/api/files.js";
import { generateFileURLFromBase64 } from "@/utils/download";

async function downloadFile(packageAttachments, attachment){

	if (attachment) {
		let file_content = packageAttachments.find(
			(s) => s.filename === attachment
		).file_content;

		const result = await apiFiles.findOne(file_content);

		try {

			/* Generate fileURL from the base64 value */
			const fileURL = generateFileURLFromBase64(
				result.data.data,
				'application/pdf;base64',
			)

			/* Opening the generated file URL */
			window.open(fileURL);
		} catch(err) {
			console.error({err, message: "Unable to preview attachment!"});
			throw new Error(err);
		}
	}
 }

export { downloadFile }
